import {gql} from "@apollo/client";

export const BATCH_SET_DELIVERED_STATUS = gql`
    mutation BatchSetDeliveredStatus($input: BatchSetDeliveredStatusInput!) {
        batchSetDeliveredStatus(input: $input) {
            finalStatus
            errorCode
            message
            results {
                success
                errorCode
                message
                trackingNumber
            }
        }
    }
`;

export interface OrderDeliveredStatusInput {
    trackingNumber: string;
    podImageS3KeysJson: string[];
}

export interface BatchSetDeliveredStatusInput {
    warehouseId?: string | null;
    orderList: OrderDeliveredStatusInput[];
}

export interface OperationResultType {
    success: boolean;
    errorCode?: string;
    message?: string;
    trackingNumber?: string;
}

export interface BatchSetDeliveredStatusResultType {
    finalStatus: number;
    errorCode?: string;
    message?: string;
    results?: OperationResultType[];
}

export interface BatchSetDeliveredStatusResponse {
    batchSetDeliveredStatus: BatchSetDeliveredStatusResultType;
}
